import {
  ChangeDetectionStrategy,
  Component,
  output,
  viewChild,
  inject,
} from '@angular/core';

import { PublicIssueFormComponent } from '../public-issue-form/public-issue-form.component';
import { PublicIssueDataSourceService } from '../../services/public-issue-data-source.service';
import { PublicIssueForm } from '../../models/public-issue-form';
import { AlertsComponent, AlertsService } from '@web/shared/ui';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';

@Component({
  selector: 'app-public-issue-panel',
  imports: [PublicIssueFormComponent, AlertsComponent],
  templateUrl: './public-issue-panel.component.html',
  styleUrl: './public-issue-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class PublicIssuePanelComponent {
  private readonly publicIssueDataSource = inject(PublicIssueDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  public readonly submitSuccessEvent = output<void>();

  protected readonly formComponentRef = viewChild.required(
    PublicIssueFormComponent,
  );

  public handleSubmitSuccessEvent(data: PublicIssueForm): void {
    this.publicIssueDataSource.createIssueByFormData(data).subscribe({
      next: () => {
        this.formComponentRef().reset();
        this.submitSuccessEvent.emit();
      },
      error: (response) => this.showFailureAlertByResponse(response),
    });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    const messages = this.httpError.extract(response).messages();

    this.alerts.showMultiple((builder) =>
      messages.map((message) => builder.buildFailure(message)),
    );
  }
}
